import Filter from '@/src/components/organism/Filter';
import { useEffect, useRef, useState } from 'react';
import { administratorFilters } from './filter';
import { useQuery } from '@tanstack/react-query';
import useQueryValues from '@/src/hooks/useQueryValues';
import MainContentTitle from '@/src/components/molecule/MainContentTitle';
import { AgGridReact } from 'ag-grid-react';
import Table from '@/src/components/atom/Table';
import { administratorListColumn } from './column';
import SectionCardNoneTitle from '@/src/components/molecule/SectionCardNoneTitle';
import Typo from '@/src/components/atom/Typo';
import Button from '@/src/components/atom/Button';
import LucideIcon from '@/src/components/atom/Icons/LucideIcon';
import usePaginationQuery from '@/src/hooks/usePaginationQuery';
import { NAV_CONST } from '@/src/constants/nav';
import { Link, useNavigate } from 'react-router-dom';
import PATH from '@/src/routes/path';
import { getAdministratorAPI } from '@/src/apis/rest/administrators';

function AdministratorListPage() {
  const navigate = useNavigate();

  const { defaultValues } = useQueryValues({
    createdAt: ['createdAtFrom', 'createdAtTo'],
  });
  const { page, pageSize, handlePageChange } = usePaginationQuery();

  const gridRef = useRef<AgGridReact>(null);
  const [values, setValues] = useState(defaultValues);

  const {
    data: administratorData,
    isError,
    isFetching,
  } = useQuery({
    queryKey: ['administrator', values, page, pageSize],
    queryFn: () => {
      return getAdministratorAPI({
        ...values,
        page,
        pageSize,
      });
    },
  });

  useEffect(() => {
    if (isFetching && gridRef.current) {
      gridRef.current.api?.showLoadingOverlay();
    }
  }, [isFetching]);

  return (
    <>
      <MainContentTitle
        pageTitle={NAV_CONST.administratorManagement}
        breadcrumbList={[NAV_CONST.administrator]}
      />
      <div className="mb-20 flex flex-col gap-6">
        <Filter
          filters={administratorFilters()}
          onSubmit={values => {
            handlePageChange(1, pageSize, false);
            setValues(values);
          }}
        />
        <div className="flex flex-col gap-y-6">
          <SectionCardNoneTitle
            contentProps={{
              className: 'flex flex-col gap-y-4',
            }}
          >
            <div className="flex items-center justify-between">
              <Typo typoType="b18m">관리자 목록</Typo>
              <Link to={PATH.ADMINISTRATOR_CREATE}>
                <Button buttonSize="medium" onClick={() => {}}>
                  <div className="flex items-center gap-x-2">
                    <LucideIcon name="Plus" color="white" />
                    관리자 등록
                  </div>
                </Button>
              </Link>
            </div>

            <Table
              ref={gridRef}
              rowData={isError ? [] : administratorData?.rows || []}
              isPaginationDataMapping
              columnDefs={administratorListColumn(e => {
                navigate(PATH.ADMINISTRATOR_DETAIL.replace(':id', String(e)));
              })}
              total={administratorData?.count || 0}
              page={page}
              pageSize={pageSize}
              handlePaginationClick={handlePageChange}
            />
          </SectionCardNoneTitle>
        </div>
      </div>
    </>
  );
}

export default AdministratorListPage;
